import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import '@vant/touch-emulator'

// import VConsole from 'vconsole' // 测试用
// new VConsole()

import { Tabbar, TabbarItem, Swipe, SwipeItem, Dialog, Popup, Overlay, Toast, DatetimePicker,
  NumberKeyboard, Rate, Uploader, PullRefresh, Skeleton, List, Tab, Tabs, Lazyload, Loading,
  Checkbox, CheckboxGroup, RadioGroup, Radio, Collapse, CollapseItem, CountDown } from 'vant' // 测试
import tag from './components/tag'
Vue.component('tag', tag)

// 底部tab
Vue.use(Tabbar)
Vue.use(TabbarItem)

// 滑动组件
Vue.use(Swipe)
Vue.use(SwipeItem)

Vue.use(Dialog)
Vue.use(Toast)

// 弹框组件
Vue.use(Popup)
Vue.use(Overlay)

Vue.use(DatetimePicker)
Vue.use(NumberKeyboard)
Vue.use(Rate)

Vue.use(Uploader)

Vue.use(PullRefresh)
Vue.use(Skeleton)
Vue.use(List)

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)

Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(CountDown)

Vue.use(require('vue-wechat-title'))

Vue.use(Loading)

Vue.use(Lazyload)
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true
})

Vue.config.productionTip = false

// eslint-disable-next-line no-use-before-define
var _hmt = _hmt || []
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?17a50ce25278391d63ca0d646e67eafe'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

// eslint-disable-next-line no-extend-native
Array.prototype.remove = function (val) {
  var index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js